import CreateAttachmentRecordError from "./CreateAttachmentRecordError";

export default class AttachmentRecordAlreadyExistsError extends CreateAttachmentRecordError {

}